import PropTypes from "prop-types";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { TextField } from "components";

const CustomDate = ({
  label,
  value,
  onChange,
  disabled,
  dateStyle,
  labelStyle,
  size = "small",
  rest,
  disablePast = false,
  disableFuture = false,
  customPadding,
  onBlur,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        value={value || null}
        disablePast={disablePast}
        disableFuture={disableFuture}
        onChange={onChange}
        disabled={disabled || false}
        inputFormat="dd/MM/yyyy"
        renderInput={(params) => (
          <TextField
            onBlur={onBlur}
            customPadding={customPadding}
            {...params}
            style={{
              ...(dateStyle && { ...dateStyle }),
            }}
            size={size}
            data-testid="date-picker"
            area-label="Choose date"
          />
        )}
      />
    </LocalizationProvider>
  );
};

CustomDate.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  dateStyle: PropTypes.object,
  disablePast: PropTypes.bool,
  disableFuture: PropTypes.bool,
};

export default CustomDate;
